import * as BrowserUtil from "./BrowserUtil";
import * as DragAndDropUtil from "./DragAndDropUtil";
import * as InputUtil from "./InputUtil";
import * as InteractUtil from "./InteractUtil";
import * as RouteUtil from "./RouteUtil";

/**
 * @deprecated do not add to this index file.
 */

export { BrowserUtil, DragAndDropUtil, InputUtil, InteractUtil, RouteUtil };
